function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgAuditTrailReport = function SvgAuditTrailReport(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Component 273 \\u2013 218",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "hdtvd1etta"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2493",
    style: {
      fill: "#262626"
    },
    d: "M0 0h18v18.009H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2339",
    style: {
      fill: "none"
    },
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4749"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4667",
    transform: "translate(1 .996)",
    style: {
      clipPath: "url(#hdtvd1etta)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1011",
    d: "M16.348 18.009h-.457a.127.127 0 0 0-.045-.025 1.98 1.98 0 0 1-1.164-.628c-.552-.561-1.11-1.11-1.664-1.666-.306-.306-.608-.617-.9-.916-.038.011-.052.014-.061.018l-.122.07a7.833 7.833 0 0 1-5.036.99 7.751 7.751 0 0 1-4.106-1.835 7.831 7.831 0 0 1-2.65-4.57C.083 9.14.047 8.827 0 8.516V7.427c.011-.052.025-.1.034-.153.063-.4.1-.8.194-1.193A7.958 7.958 0 1 1 15.2 11.269c-.131.284-.281.561-.43.851.086.081.171.162.254.243.806.808 1.621 1.61 2.42 2.427a1.857 1.857 0 0 1-.263 2.872 4.454 4.454 0 0 1-.831.347m-8.397-3.572a6.478 6.478 0 1 0-6.476-6.481 6.487 6.487 0 0 0 6.476 6.481",
    style: {
      fill: "#262626"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1012",
    d: "M4.85 5.66a1.079 1.079 0 0 1 .115-.167q1.4-1.4 2.794-2.8a.751.751 0 0 1 .761-.243.741.741 0 0 1 .394 1.177c-.041.05-.088.095-.133.14L5.426 7.125a.753.753 0 0 1-1.218 0C3.533 6.45 2.857 5.777 2.187 5.1a.74.74 0 1 1 1.06-1.031c.479.482.961.959 1.441 1.441.041.041.083.079.162.153",
    transform: "translate(2.444 3.038)",
    style: {
      fill: "#262626"
    }
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAuditTrailReport, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/audit_trail_report.ca20fbe7.svg";
export { ForwardRef as ReactComponent };